import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { MessageBoxService } from 'common/util/services/messageBox.service'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { NotifyService } from 'common/util/services/notify.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class ForgetDeletedFilesOp extends BaseOperation {
  icon = 'far fa-trash-alt'
  showInOverflowMenu = true
  supportsDirs = true
  weight = 10

  constructor (
    private translate: TranslateService,
    private api: APIService,
    private mediaPermissions: MediaPermissionsService,
    private messagebox: MessageBoxService,
    private notify: NotifyService,
  ) {
    super()
    this.label = translate.instant('Forget deleted files')
  }

  isVisibleForDir (dir) {
    return this.mediaPermissions.getPermissionForFile(dir)?.allowDeleteDb ?? false
  }

  async runForDir (dir) {
    try {
      await this.messagebox.show({
        text: this.translate.instant('This will remove info about the missing files in this directory and directories below from the database. Continue?'),
        positive: this.translate.instant('Continue'),
        negative: this.translate.instant('Cancel'),
        danger: true,
      })
    } catch {
      return
    }
    await this.api.mediaLibrary.forgetDeletedMediaFiles(dir)
    this.notify.info(this.translate.instant('Forgetting deleted files...'))
  }
}

MediaOperationsService.register(ForgetDeletedFilesOp)
